import { SelectOption } from 'Common/Form/Select';
import { EnumType } from 'context/enum.context';

export default function mapEnumsToOptions(enums: EnumType[]): SelectOption<number>[] {
  return enums.map(({ id, label }) => ({ text: label, value: id }));
}
